import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const StyledLabel = styled(Form.Label)`
  font-weight: bold;
  font: 1.5 em;
  margin-top: 5px;
`;

const FormLabel = (props) => {
  const { label } = props;

  return (
    <StyledLabel>{label}</StyledLabel>
  );
};

FormLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

export default FormLabel;
